module.exports = __webpack_public_path__ + "static/media/freezvix-4.0b2baa18.jpg";